// extracted by mini-css-extract-plugin
export default {"fullWidth":"Sn-z","image":"Tn-z","lazyLoadPicture":"Un-z","lazyLoadSpinner":"Vn-z","lazyLoadSpin":"Wn-z","lazyLoadImage":"Xn-z","hasStyledAspectRatio":"Yn-z"};